import { Directive, ElementRef, Input, HostListener } from "@angular/core";

@Directive({selector: '[phoneNumber]'})
export class PhoneNumberDirective {

  constructor(private elem: ElementRef) {}

  @HostListener('keyup') onKeyPress() {
    this.elem.nativeElement.value = this.formatPhoneNumber(this.elem.nativeElement.value);
  }

  private formatPhoneNumber(phoneNumber: string): string {
    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
    return `${phoneNumber.substr(0, 3)}${phoneNumber.length > 3 ? "-" : ""}${phoneNumber.substr(3, 3)}${phoneNumber.length > 6 ? "-" : ""}${phoneNumber.substr(6)}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/phone-number.directive.ts